import { useQuery } from '@tanstack/react-query';

import { useDataProvider } from '@/data/provider';
import type { PersonRecord } from '@/data/schemas';

const buildPersonnelKey = (companyId: string | undefined) =>
  ['companies', companyId, 'personnel'] as const;

export function useCompanyPersonnel(companyId: string | undefined) {
  const { contacts } = useDataProvider();
  return useQuery({
    queryKey: buildPersonnelKey(companyId),
    enabled: Boolean(companyId),
    queryFn: async (): Promise<PersonRecord[]> => {
      if (!companyId) {
        return [];
      }

      return contacts.listByCompany(companyId);
    },
  });
}
